import Vue from 'vue';
import Vuex from 'vuex';

import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import AWSAppSyncClient from 'aws-appsync';
import VueApollo from 'vue-apollo';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import awsConfig from './aws-exports.content';
import router from './router';
import i18n from './plugins/i18n.plugin';

import 'focus-visible';

import { store } from './store';

Amplify.configure(awsConfig);

const config = {
  url: awsConfig.aws_appsync_graphqlEndpoint,
  region: awsConfig.aws_appsync_region,
  auth: {
    type: awsConfig.aws_appsync_authenticationType,
    credentials: () => Auth.currentCredentials(),
  },
  complexObjectsCredentials: () => Auth.currentCredentials(),
  disableOffline: true,
};
const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
};
const client = new AWSAppSyncClient(config, options);
const appsyncProvider = new VueApollo({
  defaultClient: client,
});
Vue.use(VueApollo);
Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  apolloProvider: appsyncProvider,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
